
import { showVuePopup } from '../../utils/showVuePopup';
import Profile from '../../popup/Profile.vue';
import WalletDeposit from '../../popup/WalletDeposit.vue';
import AffiliateLink from '../../popup/AffiliateLink.vue';
import PromotionList from '../../popup/PromotionList.vue';
import WalletWithdraw from '../../popup/WalletWithdraw.vue';
import { useSession } from '../../stores/session';
import Button from 'primevue/button';

export default {
	name: 'PopupMainNavbar',
	components: {
		Button,
	},
	setup() {

		const session = useSession();

		const btnClickProfile = async () => {
			session.set('navbar_primary', 'profile');
			await showVuePopup(Profile);
		}

		const btnClickWallet = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:withdraw');
			await showVuePopup(WalletWithdraw);
		}

		const btnClickAffiliateLink = async () => {
			session.set('navbar_primary', 'affiliate');
			session.set('navbar_sub', 'affiliate:detail');
			await showVuePopup(AffiliateLink);
		}

		const btnClickPromotionList = async () => {
			session.set('navbar_primary', 'promotion');
			session.set('navbar_sub', 'promotion:list');
			await showVuePopup(PromotionList);
		}

		return {
			session,
			btnClickProfile,
			btnClickWallet,
			btnClickAffiliateLink,
			btnClickPromotionList,
		}
	}
}
